import {Injectable} from '@angular/core';
import {WizardStepsEnum} from '@core/enums/wizard-steps.enum';

@Injectable()
export class WizardHelperService {

    wizardSteps(): WizardStepsEnum[] {
        return [WizardStepsEnum.FINISHED, WizardStepsEnum.LANGUAGE_STYLE, WizardStepsEnum.PRESENTATION_MODE, WizardStepsEnum.INDICATIONS, WizardStepsEnum.USE_CASES];
    }

}
